import Lightbox from "stimulus-lightbox"

export default class extends Lightbox {
  connect() {
    super.connect();
  }
  get defaultOptions () {
    return {
      download: false,
      iframe: true,
      iframeWidth: '100%',
      iframeHeight: '100%',
    }
  }
}
